import type { APIInstance } from "./apiService";

export class MedChronService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async getChronology(caseId: string, versionId: string | null = null) {
    const params = versionId ? `?version_id=${versionId}` : "";
    const response = await this.api.get(`/chronology/${caseId}${params}`);
    return response.data;
  }

  async getChronologyVersions(caseId: string) {
    const response = await this.api.get(`/chronology/${caseId}/versions`);
    return response.data;
  }

  async getVisitTypes(caseId: string) {
    const response = await this.api.get(`/visit-types/${caseId}`);
    return response.data;
  }

  async updateSummary(caseId: string, field: string, value: unknown) {
    const response = await this.api.put(`/summary/${caseId}`, { field, value });
    return response.data;
  }
}
